import { Column, Typography } from '@viewup/ui';
import { termsServiceData } from './TermsService.const';

export const TermsService = () => {
  return (
    <Column gap={40}>
      {termsServiceData.map((data, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <간단한 이용약관 리스트이기 때문에 index 사용.>
        <Column gap={16} key={index}>
          <Typography color='text.assistance' fontType='body2.regular'>
            {data.title}
          </Typography>
          <Typography color='text.assistance' fontType='body2.regular'>
            {data.content}
          </Typography>
        </Column>
      ))}
    </Column>
  );
};
